import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { t } from '@lib/translation/helpers/translation.helper';

import { FsIconography } from '@lib/api/entities';

@Injectable({
  providedIn: 'root',
})
export class FsIconographyService {
  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _toastrService: ToastrService,
  ) {}

  public getIncidentIcons(): Observable<any> {
    return this._httpClient.get('/api/iconography/incidents/').pipe(
      map((response: any) => ({
        results: response.results.map((incidentIcons: any) => new FsIconography(incidentIcons)),
      })),
    );
  }

  public uploadIncidentIcons(data: any): Observable<any> {
    return this._httpClient.post('/api/iconography/incidents/', data).pipe(
      map((response: any) => new FsIconography(response)),
        tap({
          next: () => this._toastrService.success(t('iconography.toasts.iconAdded')),
          error: () =>
            this._toastrService.error(t('iconography.toasts.iconAddFailed')),
        }),
    );
  }
}
